export default __webpack_public_path__ + "static/media/Settings_FontSize.5be0c991.svg";